/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// import Image from 'next/image';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import styles from '../contentPage.module.scss';
import NextSeoWrapper from '@/components/NextSeoWrapper';
import PageContainer from '@/components/PageContainer';
import { getLanguageAlternates } from '@/utils/locale';
import { getCanonicalUrl } from '@/utils/navigation';

const path = '/welfare';
const welfarePage = () => {
    const { t, lang } = useTranslation('welfare');
    const members = [
        { sr: 1, name: "Masood Ahmad", designation: "Chairman", occupation: "Retired Army Officer" },
        { sr: 2, name: "Aftab Ahmad", designation: "Vice Chairman", occupation: "Retired Army Officer" },
        { sr: 3, name: "Abdul Rauf Khan", designation: "General Secretary", occupation: "Retired Army Officer" },
        { sr: 4, name: "Munir Ahmad", designation: "Joint secretary", occupation: "Business" },
        { sr: 5, name: "Muhammad Iqbal", designation: "Finance Secretary", occupation: "Private Job" },
        { sr: 6, name: "Muhammad Maqbool Awan", designation: "Member", occupation: "Private Job" },
        { sr: 7, name: "Muhammad Nadeem", designation: "Member", occupation: "Business" },
    ];
    return (
        <>
            <NextSeoWrapper
                title="welfare"
                url={getCanonicalUrl(lang, path)}
                languageAlternates={getLanguageAlternates(path)}
            />
            <PageContainer>
                <div className={styles.historyPage}>
                    <h1 style={{ textAlign: 'center' }}>{t('welfare:welfare-name')}</h1>
                    <p style={{ textAlign: 'center' }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:parahgraph-1"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('welfare:founder')}</h1>
                    <p style={{ textAlign: 'center', fontWeight: "bolder" }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:parahgraph-2"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('welfare:aim-obj')}</h1>
                    {Array.from({ length: 27 }, (_, i) => (
                        <p key={i} style={{ fontWeight: "bold" }} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:aim-obj-txt-${i + 1}`} />
                        </p>
                    ))}

                    <p style={{ fontWeight: "bold" }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:aim-obj-txt-27-1"
                        />
                    </p>
                    <p style={{ fontWeight: "bold" }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:aim-obj-txt-27-2"
                        />
                    </p>
                    <p style={{ fontWeight: "bold" }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:aim-obj-txt-27-3"
                        />
                    </p>
                    <p style={{ fontWeight: "bold" }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:aim-obj-txt-27-4"
                        />
                    </p>
                    <p style={{ fontWeight: "bold" }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:aim-obj-txt-28"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center' }}>{t('welfare:b-list')}</h1>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>Sr No</th>
                                    <th>Name</th>
                                    <th>Designation</th>
                                    <th>Occupation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {members.map((member) => (
                                    <tr key={member.sr}>
                                        <td>{member.sr}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                        <td>{member.occupation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <h1 style={{ textAlign: 'center', fontWeight: "bold" }}>{t('welfare:power-and-duties')}</h1>
                    <h1 style={{  fontWeight: "bold" }}>{t('welfare:chair-man')}</h1>
                    {Array.from({ length: 7 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:chairman-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{  fontWeight: "bold" }}>{t('welfare:vice-chairman')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:vice-chairman-txt"
                        />
                    </p>
                    <h1 style={{  fontWeight: "bold" }}>{t('welfare:G-S')}</h1>
                    {Array.from({ length: 7 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:general-secretary-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{  fontWeight: "bold" }}>{t('welfare:J-S')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:j-S-txt"
                        />
                    </p>
                    <h1 style={{  fontWeight: "bold" }}>{t('welfare:F-S')}</h1>
                    {Array.from({ length: 4 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:finance-secretary-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{  fontWeight: "bold" }}>{t('welfare:member')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:member-txt"
                        />
                    </p>
                    <h1 style={{ textAlign: 'center', fontWeight: "bold" }}>{t('welfare:R-R')}</h1>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:defination')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:defination-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:address')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:address-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:membership')}</h1>
                    {Array.from({ length: 4 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:membership-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:notice')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:notice-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:disqualification')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:disqualification-txt"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:following"
                        />
                    </p>
                    {Array.from({ length: 6 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:following-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:election')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:election-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:source-of-income')}</h1>
                    {Array.from({ length: 2 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:source-of-income-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:bank-acc')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:bank-acc-txt-1"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:bank-acc-txt-2"
                        />
                    </p>
                    {Array.from({ length: 2 }, (_, i) => (
                        <p style={{ fontWeight: "bold" }} key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`welfare:bank-acc-opt-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:meeting')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:meeting-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:post-meeting')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:post-meeting-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:audit')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:audit-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:quorum')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:quorum-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:amendment')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:amendment-txt"
                        />
                    </p>
                    <h1 style={{ fontWeight: "bold" }}>{t('welfare:dissolution')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="welfare:dissolution-txt"
                        />
                    </p>
                </div>
            </PageContainer>
        </>
    );
};

export default welfarePage;
